module.exports = __webpack_public_path__ + "img/faq3_1-md.2c737a47.png";